<template>
  <div>
    <PCNavbar selectIndex="3"/>
    <!-- <MobileNavBar :currentActive="1" /> -->
     <ServerPage />
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
// import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import ServerPage from '@/components/serverPage/index.vue'
export default {
  components: {
    PCNavbar,
    // MobileNavBar
    ServerPage
  },
}
</script>

<style>
</style>